// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEPRECATED: Migrate to ez-spinner.js functionality */
/* DEPRECATED */
.spinnerOverlay {
  text-align: center;
}

/* DEPRECATED */
.overlayLabel {
  padding: 4px;
  margin-top: 10%;
  margin-left: 25%;
  margin-right: 25%;
  background-color: var(--ezAlphaBackgroundWhite);
  color: var(--ezClockerBlack);
  font-size: 52pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerWhite);
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ezclocker-spinner.css"],"names":[],"mappings":"AAAA,uDAAA;AAEA,eAAA;AAAgB;EACZ,kBAAA;AACJ;;AAEA,eAAA;AAAgB;EACZ,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;AAEJ","sourcesContent":["/* DEPRECATED: Migrate to ez-spinner.js functionality */\n\n/* DEPRECATED */.spinnerOverlay {\n    text-align: center;\n}\n\n/* DEPRECATED */.overlayLabel {\n    padding: 4px;\n    margin-top: 10%;\n    margin-left: 25%;\n    margin-right: 25%;\n    background-color: var(--ezAlphaBackgroundWhite);\n    color: var(--ezClockerBlack);\n    font-size: 52pt;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezClockerWhite);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
